module.exports = __webpack_public_path__ + "media/images/ball_wide_main-5c66d0b6e11fe19b90c808264fba16cd.png";